import { clampNormRect } from "../editor/coords.js";
const CENTER_LINES = [0.5];
const THIRD_LINES = [1 / 3, 2 / 3];
export function slideGuideLines(otherRects) {
    const lines = [];
    for (const v of CENTER_LINES) {
        lines.push({ axis: "x", value: v, kind: "center" });
        lines.push({ axis: "y", value: v, kind: "center" });
    }
    for (const v of THIRD_LINES) {
        lines.push({ axis: "x", value: v, kind: "third" });
        lines.push({ axis: "y", value: v, kind: "third" });
    }
    for (const r of otherRects) {
        lines.push({ axis: "x", value: r.x, kind: "layer" });
        lines.push({ axis: "x", value: r.x + r.w, kind: "layer" });
        lines.push({ axis: "x", value: r.x + r.w / 2, kind: "layer" });
        lines.push({ axis: "y", value: r.y, kind: "layer" });
        lines.push({ axis: "y", value: r.y + r.h, kind: "layer" });
        lines.push({ axis: "y", value: r.y + r.h / 2, kind: "layer" });
    }
    return lines;
}
/** Snap rect edges/centers to guide lines within threshold (normalized). */
export function snapRectToGuides(rect, guides, threshold = 0.012) {
    let { x, y, w, h } = rect;
    const points = { x: [x, x + w / 2, x + w], y: [y, y + h / 2, y + h] };
    for (const guide of guides) {
        if (guide.axis === "x") {
            for (let i = 0; i < points.x.length; i += 1) {
                if (Math.abs(points.x[i] - guide.value) <= threshold) {
                    const delta = guide.value - points.x[i];
                    if (i === 0)
                        x += delta;
                    else if (i === 1)
                        x += delta;
                    else
                        x += delta;
                    points.x = [x, x + w / 2, x + w];
                }
            }
        }
        else {
            for (let i = 0; i < points.y.length; i += 1) {
                if (Math.abs(points.y[i] - guide.value) <= threshold) {
                    const delta = guide.value - points.y[i];
                    y += delta;
                    points.y = [y, y + h / 2, y + h];
                }
            }
        }
    }
    return clampNormRect({ x, y, w, h });
}
export function rectsOverlap(a, b, margin = 0.005) {
    return !(a.x + a.w <= b.x + margin ||
        b.x + b.w <= a.x + margin ||
        a.y + a.h <= b.y + margin ||
        b.y + b.h <= a.y + margin);
}
export function rectInside(inner, outer, epsilon = 0.01) {
    return (inner.x >= outer.x - epsilon &&
        inner.y >= outer.y - epsilon &&
        inner.x + inner.w <= outer.x + outer.w + epsilon &&
        inner.y + inner.h <= outer.y + outer.h + epsilon);
}
